
import BaseComponent from '../base_component/base_component'
import componentLocator from "../../assets/javascripts/component_locator";

export default class ContactActions extends BaseComponent {

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
    }

     getSelectedContacts() {
        let selectedContacts = [];
        let selectedContactsMap = new Map();

        $(this.component)
            .closest('.data-table-component')
            .find('input[type="checkbox"]:checked')
            .each((i: number, element: Element) => {
                let contactId = element.getAttribute('data-contact-id');
                let contactName = element.getAttribute('data-contact-name');
                if (contactId){
                    selectedContacts.push(contactId);
                    if(contactName){
                        selectedContactsMap.set(contactId, contactName);
                    }
                }
            });
        return selectedContactsMap;
    }

    expireContacts(){

        let contactsMap = this.getSelectedContacts();
        let contactIds = [ ...contactsMap.keys() ];
        let contactNames = [ ...contactsMap.values() ];
        getComponent('modal').show('confirmation', {title: 'Confirm Deactivation', message: `Are you sure you want to deactivate these contacts?\n\n${contactNames.join('\n')}`});
        let result = false;
        /*componentLocator.waitUntilLoaded().then(async () => {
            result = componentLocator.f.getConfirmationResult();
            debugger;
        });*/

        // if(!result)
        //     return;

        let headers: {[string]: any} = {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        };
        $.ajax({
            type: "POST",
            url: '/expire_contacts',
            data: JSON.stringify({
                'contact_ids': contactIds
            }),
            dataType: 'json',
            contentType: 'application/json',
            headers: headers,
            success: function(data) {
                console.log('Successfully deactivated contacts');
                componentLocator.f.reloadData()
                return data;
            },
            error: function() {
                console.log('Error: unable to deactivate contacts');
            }
        });

    }

}